import React from 'react';
import {useNavigate} from 'react-router-dom';

import {createAttributeRoutePath} from 'src/modules/attributes/attributes-route-planner';

import Group from '@pb/kit-component-group';
import {MoreLessButton} from '@pb/kit-component-more-less';
import {Pill} from '@pb/kit-component-strip-of-pills';

import {eventCodePillsStrip, eventCodePillsStripFont} from './event-code-pills-strip.module.styl';

type Props = {
    eventCodes: Array<string>,
    attributeName: string,
    attributeId: number,
};

export const EventCodePillsStrip = (props: Props) => {
    const navigate = useNavigate();
    const {attributeName, eventCodes, attributeId} = props;

    const onChange = () => {
        const attributeRoutePath = createAttributeRoutePath({attributeName, attributeId});
        navigate(attributeRoutePath);
    };

    return (
        <Group gap="xs" alignItems="center" wrap="wrap">
            {eventCodes.slice(0, 7).map(code => (
                <Pill key={code} name={code} className={`${eventCodePillsStrip} ${eventCodePillsStripFont}`}/>
            ))}
            <MoreLessButton onChange={onChange} isCollapsed={true}/>
        </Group>
    );
};
